export default "__VITE_ASSET__D4EmMG4J__"